"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellRef = void 0;
exports.findIterator = findIterator;
exports.findHorizontal = findHorizontal;
exports.findVertical = findVertical;
exports.findCell = findCell;
exports.collectIterator = collectIterator;
exports.collectHorizontal = collectHorizontal;
exports.collectVertical = collectVertical;
class CellRef {
    constructor(col, row) {
        this.col = col;
        this.row = row;
    }
    toString() {
        return `CellRef(${this.col}, ${this.row})`;
    }
    nextColumn(row) {
        return new CellRef(this.col + 1, row !== undefined ? row : this.row);
    }
    nextRow(col) {
        return new CellRef(col !== undefined ? col : this.col, this.row + 1);
    }
    get(grid) {
        return grid[this.row][this.col];
    }
    with(col, row) {
        return new CellRef(col === undefined ? this.col : col, row === undefined ? this.row : row);
    }
    contained(grid) {
        return grid.length > this.row && grid[this.row].length > this.col;
    }
}
exports.CellRef = CellRef;
function defaultToOrigin(ref) {
    if (ref) {
        return ref;
    }
    return new CellRef(0, 0);
}
function testCell(test, grid, ref) {
    const cell = ref.get(grid);
    const found = test(cell, ref);
    if (found instanceof CellRef) {
        return found;
    }
    else if (found) {
        return ref;
    }
}
function horizontalNext(grid, from) {
    const next = from.nextColumn();
    if (next.contained(grid)) {
        return next;
    }
    return null;
}
function verticalNext(grid, from) {
    const next = from.nextRow();
    if (next.contained(grid)) {
        return next;
    }
    return null;
}
function horizontalFirstNext(grid, from) {
    const next = horizontalNext(grid, from);
    if (next) {
        return next;
    }
    return verticalNext(grid, from.with(0));
}
function findIterator(grid, test, iterator, from) {
    let ref = defaultToOrigin(from);
    if (!ref.contained(grid)) {
        return undefined;
    }
    while (ref) {
        const found = testCell(test, grid, ref);
        if (found) {
            return found;
        }
        ref = iterator(grid, ref);
    }
}
// Searches for the next cell where `pred` evaluates to true.
function findHorizontal(grid, test, from) {
    return findIterator(grid, test, (horizontalNext), from);
}
// Searches for the next cell where `pred` evaluates to true.
function findVertical(grid, test, from) {
    return findIterator(grid, test, (verticalNext), from);
}
// Searches for the next cell where `pred` evaluates to true. Searches row by row.
function findCell(grid, test, from) {
    return findIterator(grid, test, (horizontalFirstNext), from);
}
function collectIterator(grid, test, iterator, from) {
    let ref = defaultToOrigin(from);
    if (!ref.contained(grid)) {
        return [];
    }
    const result = [];
    while (ref) {
        const found = testCell(test, grid, ref);
        if (found) {
            result.push(found);
        }
        ref = iterator(grid, ref);
    }
    return result;
}
function collectHorizontal(grid, test, from) {
    return collectIterator(grid, test, (horizontalNext), from);
}
function collectVertical(grid, test, from) {
    return collectIterator(grid, test, (verticalNext), from);
}
